import $ from 'jquery';

//Arrow top bottom for picking quantity product

$('<div class="quantity-nav"><div class="quantity-button quantity-down"></div><div class="quantity-button quantity-up"></div></div>').insertAfter('.input-text.qty.text');

$('.quantity').each(function() {
    var spinner = $(this),
    input = spinner.find('input[type="number"]'),
    btnUp = spinner.find('.quantity-up'),
    btnDown = spinner.find('.quantity-down'),
    min = input.attr('min'),
    max = input.attr('max');
    
    btnUp.click(function() {
    var oldValue = parseFloat(input.val());
    var newVal = oldValue + 1;
    spinner.find('input[type="number"]').val(newVal);
    spinner.find('input[type="number"]').trigger("change");
    });
    btnDown.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
    var newVal = oldValue;
    } else {
    var newVal = oldValue - 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
    });

  });
